<template>
  <div>
    <form-section :title="$t('Integrations_Settings_BasicSettings')">
      <rest-form-item
        :label="$t('Integrations_Field_Name')"
        :hint="$t('Integrations_Field_Name_Description')"
        prop="name"
      >
        <el-input
          v-model="model.name"
          :placeholder="$t('Integrations_Field_Name')"
        />
      </rest-form-item>
    </form-section>

    <form-section :title="$t('Integrations_Settings_ConnectionSettings')">
      <rest-form-item
        :label="$t('Integrations_Alira_Field_Endpoint')"
        prop="params.endpoint"
      >
        <el-input v-model="model.params.endpoint" />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_Alira_Field_Alias')"
        prop="params.alias"
      >
        <el-input v-model="model.params.alias" />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_Alira_Field_Password')"
        prop="params.password"
      >
        <el-input v-model="model.params.password" type="password" />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_Alira_Field_PartnerId')"
        prop="params.partner_id"
      >
        <el-input v-model="model.params.partner_id" />
      </rest-form-item>
    </form-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'
import { isValidUrl } from '@/core/helpers'

export default {
  name: 'AliraSettings',

  components: {
    FormSection,
    RestFormItem
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  data() {
    let validateUrl = (rule, value, callback) => {
      if (isValidUrl(value)) {
        callback()
      } else {
        callback(new Error(this.urlValidationMessage))
      }
    }
    return {
      urlValidationMessage: this.$t('RestForm_FieldInvalidUrl'),
      rules: {
        name: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        },
        params: {
          password: [
            {
              required: true,
              message: this.$t('RestForm_FieldIsRequired')
            }
          ],
          endpoint: [
            {
              required: true,
              message: this.$t('RestForm_FieldIsRequired')
            },
            {
              validator: validateUrl
            }
          ],
          partner_id: [
            {
              required: true,
              message: this.$t('RestForm_FieldIsRequired')
            }
          ],
          alias: [
            {
              required: true,
              message: this.$t('RestForm_FieldIsRequired')
            }
          ]
        }
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/integrations/types/alira/AliraSettings.vue